export enum EConsentMode {
  GRANTED = 'granted',
  DENIED = 'denied'
}